// AUTO-GENERATED — do not edit. Source: theme/assets/beautymaker-quiz-*.js
// Regenerate with: node tools/build-bundle.mjs
(function () {
// ===== beautymaker-quiz-data.js =====
// beautymaker-quiz-data.js — single source of quiz content (ES module).
// Customer-facing copy uses "decor" (no accent) per brand preference.

const PERSONAS = {
  curator:   { name: "Curator Beautymaker",   desc: "You make beauty through intentional choices. You invest in statement pieces that reflect your vision and create spaces that feel authentically yours." },
  gathering: { name: "Gathering Beautymaker", desc: "You make beauty to bring people together. Your home is your canvas for celebration—every meal, gathering, and season is an opportunity to make others feel welcomed and cherished." },
  everyday:  { name: "Everyday Beautymaker",  desc: "You make beauty a year-round practice. You see decorating as a continuous journey of discovery and invest in timeless pieces that grow more meaningful over time." },
  inspired:  { name: "Inspired Beautymaker",  desc: "You're learning to make beauty happen. You appreciate guidance and curated inspiration, and find joy in transforming spaces affordably—one beautiful choice at a time." },
};

// Q1–Q5 are scored. Each option's `pts` awards weighted points per persona — Sarah's confirmed matrix.
const QUESTIONS = [
  { id: "q1", title: "What draws you to Interior Delights?", options: [
    { label: "Statement furniture pieces that anchor a room",  pts: { curator: 2 } },
    { label: "Curated accents and smaller decor items",         pts: { inspired: 2 } },
    { label: "Seasonal and holiday collections",                pts: { gathering: 1, everyday: 1 } },
    { label: "Entertaining and hosting essentials",             pts: { gathering: 2 } } ] },
  { id: "q2", title: "When do you typically shop for home decor?", options: [
    { label: "When I spot something I love—impulse driven",     pts: { curator: 2, everyday: 1 } },
    { label: "During seasonal sales or promotions",             pts: { inspired: 2 } },
    { label: "Before hosting or a specific room project",       pts: { gathering: 2 } },
    { label: "Year-round as part of my lifestyle",              pts: { curator: 1, everyday: 2 } } ] },
  { id: "q3", title: "Which room are you most focused on right now?", options: [
    { label: "Living Room",            pts: { curator: 1, gathering: 1 }, room: "living_room" },
    { label: "Bedroom",                pts: { curator: 1, everyday: 1 },  room: "bedroom" },
    { label: "Dining Room / Kitchen",  pts: { gathering: 2 },             room: "dining_kitchen" },
    { label: "Outdoor Space",          pts: { gathering: 1, everyday: 1 }, room: "outdoor" } ] },
  { id: "q4", title: "How do you approach decorating?", options: [
    { label: "I know my style and buy with confidence",         pts: { curator: 2 } },
    { label: "I like inspiration but make my own choices",      pts: { curator: 1, everyday: 1 } },
    { label: "I appreciate guidance and curated recommendations", pts: { inspired: 2 } },
    { label: "I need help pulling it all together",             pts: { inspired: 2 } } ] },
  { id: "q5", title: "What inspires your decorating choices?", options: [
    { label: "Luxury lifestyle brands and high-end design",     pts: { curator: 2 } },
    { label: "Budget-friendly options that look great",         pts: { inspired: 2 } },
    { label: "Design trends and what's new",                    pts: { everyday: 2 } },
    { label: "Timeless, investment pieces I'll keep forever",   pts: { curator: 1, everyday: 2 } } ] },
];

// Persona assignment thresholds (Sarah's spec). A persona "qualifies" at/above its threshold.
// inspiredSoleLeader: Inspired also qualifies at 4 if it's the strict highest score.
const THRESHOLDS = { curator: 6, gathering: 5, everyday: 5, inspired: 5, inspiredSoleLeader: 4 };

// Q6 preferences (multi-select). `segment` = the Klaviyo segment / Email_Preferences label.
const EMAIL_PREFS = [
  { key: "pref_holiday",       segment: "Holiday Shopper",                       label: "Holiday and seasonal decor inspiration" },
  { key: "pref_sales",         segment: "Sales and Promo Shopper",               label: "Sales, promotions, and exclusive offers" },
  { key: "pref_weekly_letter", segment: "ID Enthusiast Master List Shopper",     label: "Weekly insider letter with new arrivals and curated picks from Sarah" },
  { key: "pref_styling_tips",  segment: "Product Specific Inspiration Customer", label: "Styling tips and recommendations based on items you've purchased" },
];

// Q6 + email step content, in the data module (no hand-built copy in JS). Counts as step 6 of 6.
const Q6 = {
  prefsTitle: "What kind of content would you like to receive from Interior Delights? (Select all that apply)",
  birthdayTitle: "We'd love to send you a special gift on your birthday. When should we celebrate with you?",
  emailTitle: "Almost there! Enter your email to receive your free gift code.",
  consentLabel: "Yes, email me Interior Delights news and offers.",
};

// ===== beautymaker-quiz-scoring.js =====
// beautymaker-quiz-scoring.js — pure persona scoring (ES module).
// Implements Sarah's weighted matrix + thresholds. Ties at the top return BOTH personas
// (per Sarah: "give the offer for both"). Fallback when nobody meets a threshold = highest score.


const PERSONA_KEYS = ["curator", "gathering", "everyday", "inspired"];

// answers: { q1: 0..3, q2: 0..3, ... }  ->  { scores, personas: [winner key(s)] }
function scoreQuiz(answers) {
  const scores = { curator: 0, gathering: 0, everyday: 0, inspired: 0 };
  for (const q of QUESTIONS) {
    const idx = answers[q.id];
    const opt = Number.isInteger(idx) ? q.options[idx] : null;
    if (opt && opt.pts) for (const k in opt.pts) scores[k] += opt.pts[k];
  }
  return { scores, personas: assignPersonas(scores) };
}

// Convenience: just the winning persona key(s) as an array (1 = clear winner, 2+ = tie -> show all).
function scorePersona(answers) {
  return scoreQuiz(answers).personas;
}

function assignPersonas(scores) {
  const qualified = PERSONA_KEYS.filter((p) => {
    if (p === "inspired") {
      if (scores.inspired >= THRESHOLDS.inspired) return true;
      // Inspired also qualifies at 4+ when it's the strict highest score.
      return scores.inspired >= THRESHOLDS.inspiredSoleLeader &&
        PERSONA_KEYS.every((o) => o === "inspired" || scores[o] < scores.inspired);
    }
    return scores[p] >= THRESHOLDS[p];
  });
  // Use qualifiers if any; otherwise fall back to all four (highest score wins).
  const pool = qualified.length ? qualified : PERSONA_KEYS.slice();
  const top = Math.max(...pool.map((p) => scores[p]));
  // Winner(s) = pool personas at the top score. A tie returns multiple -> show both.
  return pool.filter((p) => scores[p] === top);
}

// ===== beautymaker-quiz-klaviyo.js =====
// beautymaker-quiz-klaviyo.js — client-side Klaviyo writes (ES module).
// Custom properties ride the EVENT call (the subscription endpoint rejects them).
// /client/* endpoints are CORS-enabled for the public key — no proxy, no credentials.
// Property names match Sarah's scope: Beautymaker_Persona, Email_Preferences, Birthday, Quiz_Completed_Date.


const KLAVIYO_REVISION = "2026-04-15"; // re-confirm against current Klaviyo Client API docs
const BASE = "https://a.klaviyo.com/client";

const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

// MM/DD/YYYY (or MM/DD when no year). Undefined when month/day missing.
const birthdayStr = (b) =>
  b && b.month && b.day ? (b.year ? `${b.month}/${b.day}/${b.year}` : `${b.month}/${b.day}`) : undefined;

// personas: array of persona keys (1 = clear winner, 2 = tie). -> "Curator" | "Curator, Everyday"
function personaLabel(personas) {
  return (Array.isArray(personas) ? personas : [personas]).map(cap).join(", ");
}

function profileProps(state, personas) {
  const props = {
    Beautymaker_Persona: personaLabel(personas),
    room_interest: state.room || null,
  };
  // Selected content prefs -> comma-separated Klaviyo segment names.
  const segments = EMAIL_PREFS.filter((p) => (state.prefs || []).includes(p.key)).map((p) => p.segment);
  props.Email_Preferences = segments.join(", ");
  const bday = birthdayStr(state.birthday);
  if (bday) props.Birthday = bday;
  if (state.completedAt) props.Quiz_Completed_Date = state.completedAt;
  return props;
}

function profileAttributes(state, personas) {
  const attrs = { email: state.email, properties: profileProps(state, personas) };
  if (state.firstName) attrs.first_name = state.firstName; // standard Klaviyo attribute (email personalization)
  return attrs;
}

function buildEvent(state, personas) {
  return { data: { type: "event", attributes: {
    metric: { data: { type: "metric", attributes: { name: "Completed Beautymaker Quiz" } } },
    properties: { persona: personaLabel(personas) },
    profile: { data: { type: "profile", attributes: profileAttributes(state, personas) } },
  } } };
}

function buildSubscription(state, listId) {
  return { data: { type: "subscription",
    attributes: { profile: { data: { type: "profile", attributes: {
      email: state.email,
      subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } },
    } } } },
    relationships: { list: { data: { type: "list", id: listId } } },
  } };
}

async function post(path, companyId, body) {
  const res = await fetch(`${BASE}/${path}/?company_id=${companyId}`, {
    method: "POST", mode: "cors",
    headers: { "Content-Type": "application/vnd.api+json", "revision": KLAVIYO_REVISION },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`Klaviyo ${path} ${res.status}`); // events return 202
  return res;
}

// root = the #bm-quiz element carrying data-klaviyo-key / data-klaviyo-list.
async function syncToKlaviyo(root, state, personas) {
  const companyId = root.dataset.klaviyoKey;
  const listId = root.dataset.klaviyoList;
  await post("events", companyId, buildEvent(state, personas));               // sets profile + custom props
  if (state.consent) await post("subscriptions", companyId, buildSubscription(state, listId)); // consent + list
}

// ===== beautymaker-quiz.js =====
// beautymaker-quiz.js — quiz step machine (vanilla ES module).
// Flow: Q1–Q5 -> Q6 (prefs + birthday) -> persona reveal -> email capture -> coupon unlock.




const rootEl = document.getElementById("bm-quiz");
if (rootEl) init(rootEl);

function init(root) {
  const STORE = "bm-quiz-progress";
  const state = loadState(STORE);
  const landingEl = root.querySelector(".bm-quiz__landing");
  const stepsEl = root.querySelector(".bm-quiz__steps");
  const resultsEl = root.querySelector(".bm-quiz__results");

  const TOTAL = QUESTIONS.length + 1;          // Q1–Q5 + Q6 = 6 numbered questions
  const RESULTS_STEP = QUESTIONS.length + 1;   // persona reveal (before email)
  const EMAIL_STEP = QUESTIONS.length + 2;     // email capture (unlocks the gift)
  let step = 0;

  const save = () => { try { sessionStorage.setItem(STORE, JSON.stringify(state)); } catch (e) {} };

  root.querySelector(".bm-quiz__start").addEventListener("click", () => {
    landingEl.hidden = true; stepsEl.hidden = false; render();
  });

  function render() {
    stepsEl.innerHTML = "";
    if (step < QUESTIONS.length) return renderQuestion(QUESTIONS[step], step);
    if (step === QUESTIONS.length) return renderQ6();
    if (step === RESULTS_STEP) return renderPersona();
    if (step === EMAIL_STEP) return renderEmail();
  }

  function progress(current) {
    const p = el("p", "bm-quiz__progress");
    p.textContent = `Question ${current} of ${TOTAL}`;
    return p;
  }

  function nav(onBack, onNext, nextLabel) {
    const row = el("div", "bm-quiz__nav");
    if (onBack) { const b = el("button", "bm-quiz__back"); b.type = "button"; b.textContent = "Back"; b.addEventListener("click", onBack); row.appendChild(b); }
    const next = el("button", "bm-quiz__next"); next.type = "button"; next.textContent = nextLabel || "Next"; next.addEventListener("click", onNext); row.appendChild(next);
    return { row, next };
  }

  function renderQuestion(q, idx) {
    const wrap = el("div", "bm-quiz__step");
    wrap.appendChild(progress(idx + 1));
    const h = el("h2", "bm-quiz__q"); h.textContent = q.title; wrap.appendChild(h);

    const opts = el("div", "bm-quiz__options");
    q.options.forEach((opt, i) => {
      const label = el("label", "bm-quiz__option");
      const input = document.createElement("input");
      input.type = "radio"; input.name = q.id; input.value = i;
      if (state.answers[q.id] === i) { input.checked = true; label.classList.add("is-selected"); }
      input.addEventListener("change", () => {
        state.answers[q.id] = i;
        if (q.id === "q3") state.room = opt.room;
        save();
        opts.querySelectorAll(".bm-quiz__option").forEach(l => l.classList.remove("is-selected"));
        label.classList.add("is-selected");
        n.next.disabled = false;
      });
      const span = document.createElement("span"); span.textContent = opt.label;
      label.appendChild(input); label.appendChild(span); opts.appendChild(label);
    });
    wrap.appendChild(opts);

    const n = nav(idx > 0 ? () => { step--; render(); } : null, () => { step++; render(); });
    n.next.disabled = !Number.isInteger(state.answers[q.id]);
    wrap.appendChild(n.row);
    stepsEl.appendChild(wrap);
  }

  function renderQ6() {
    const wrap = el("div", "bm-quiz__step");
    wrap.appendChild(progress(TOTAL));
    const h = el("h2", "bm-quiz__q"); h.textContent = Q6.prefsTitle; wrap.appendChild(h);

    const prefs = el("div", "bm-quiz__prefs");
    EMAIL_PREFS.forEach(pref => {
      const label = el("label", "bm-quiz__check");
      const input = document.createElement("input"); input.type = "checkbox";
      if (state.prefs.includes(pref.key)) input.checked = true;
      input.addEventListener("change", () => {
        if (input.checked) { if (!state.prefs.includes(pref.key)) state.prefs.push(pref.key); }
        else state.prefs = state.prefs.filter(k => k !== pref.key);
        save();
      });
      const span = document.createElement("span"); span.textContent = pref.label;
      label.appendChild(input); label.appendChild(span); prefs.appendChild(label);
    });
    wrap.appendChild(prefs);

    const bt = el("p", "bm-quiz__bday-title"); bt.textContent = Q6.birthdayTitle; wrap.appendChild(bt);
    const bday = el("div", "bm-quiz__bday");
    const months = ["Month","January","February","March","April","May","June","July","August","September","October","November","December"];
    const monthOpts = months.map((m, i) => ({ v: i === 0 ? "" : pad(i), t: m }));
    const dayOpts = [{ v: "", t: "Day" }].concat(seq(1, 31).map(d => ({ v: pad(d), t: String(d) })));
    const yearOpts = [{ v: "", t: "Year" }].concat(seq(2026, 1926, -1).map(y => ({ v: String(y), t: String(y) })));
    const mSel = select(monthOpts, state.birthday.month);
    const dSel = select(dayOpts, state.birthday.day);
    const ySel = select(yearOpts, state.birthday.year);
    [mSel, dSel, ySel].forEach(s => {
      s.addEventListener("change", () => { state.birthday = { month: mSel.value, day: dSel.value, year: ySel.value }; save(); });
      bday.appendChild(s);
    });
    wrap.appendChild(bday);

    const n = nav(() => { step--; render(); }, () => { computeResult(); step = RESULTS_STEP; render(); });
    wrap.appendChild(n.row);
    stepsEl.appendChild(wrap);
  }

  function computeResult() {
    state.personas = scorePersona(state.answers);
    save();
  }

  // Persona reveal — shown BEFORE email capture. A tie shows both personas (Sarah's rule).
  function renderPersona() {
    const personas = (state.personas && state.personas.length) ? state.personas : scorePersona(state.answers);
    const wrap = el("div", "bm-quiz__step bm-quiz__reveal");
    const eyebrow = el("p", "bm-quiz__eyebrow");
    eyebrow.textContent = personas.length > 1 ? "You're a blend of two beautymakers" : "You are a";
    wrap.appendChild(eyebrow);
    personas.forEach(key => {
      const data = PERSONAS[key] || PERSONAS.curator;
      const h = el("h2", "bm-quiz__persona"); h.textContent = data.name; wrap.appendChild(h);
      const d = el("p", "bm-quiz__desc"); d.textContent = data.desc; wrap.appendChild(d);
    });
    const tease = el("p", "bm-quiz__gift-tease"); tease.textContent = "We have a special gift especially for you!";
    wrap.appendChild(tease);

    const n = nav(() => { step = QUESTIONS.length; render(); }, () => { step = EMAIL_STEP; render(); }, "Get my free gift →");
    wrap.appendChild(n.row);
    stepsEl.appendChild(wrap);
  }

  function renderEmail() {
    const wrap = el("div", "bm-quiz__step");
    const h = el("h2", "bm-quiz__q"); h.textContent = Q6.emailTitle; wrap.appendChild(h);

    const nameField = document.createElement("input");
    nameField.type = "text"; nameField.className = "bm-quiz__name"; nameField.placeholder = "First name (optional)";
    nameField.autocomplete = "given-name"; nameField.value = state.firstName || "";
    wrap.appendChild(nameField);

    const field = document.createElement("input");
    field.type = "email"; field.className = "bm-quiz__email"; field.placeholder = "you@email.com";
    field.autocomplete = "email"; field.value = state.email || "";
    wrap.appendChild(field);

    const cLabel = el("label", "bm-quiz__check bm-quiz__consent");
    const consent = document.createElement("input"); consent.type = "checkbox"; if (state.consent) consent.checked = true;
    const cSpan = document.createElement("span"); cSpan.textContent = Q6.consentLabel;
    cLabel.appendChild(consent); cLabel.appendChild(cSpan); wrap.appendChild(cLabel);

    const err = el("p", "bm-quiz__error"); err.hidden = true; err.textContent = "Please enter a valid email so we can send your gift code."; wrap.appendChild(err);
    field.addEventListener("input", () => { if (validEmail(field.value.trim())) err.hidden = true; });

    const n = nav(() => { step = RESULTS_STEP; render(); }, () => {
      const email = field.value.trim();
      if (!validEmail(email)) { err.hidden = false; field.focus(); return; }
      state.email = email; state.consent = consent.checked; state.firstName = nameField.value.trim(); save();
      finish();
    }, "Get my gift code");
    wrap.appendChild(n.row);
    stepsEl.appendChild(wrap);
  }

  function finish() {
    const personas = (state.personas && state.personas.length) ? state.personas : scorePersona(state.answers);
    state.personas = personas;
    state.completedAt = new Date().toISOString();
    save();
    renderCoupon(personas);
    if (!state.synced) {
      state.synced = true; save();
      syncToKlaviyo(root, state, personas).catch(() => {
        setTimeout(() => syncToKlaviyo(root, state, personas).catch(() => {}), 1500);
      });
    }
  }

  // Gift rule (Sarah, 7/3): weekly-insider-letter subscribers get the candle; everyone else the $20 coupon.
  // Codes are unique per person and arrive by email, so no code is shown on-page.
  function renderCoupon(personas) {
    stepsEl.hidden = true;
    resultsEl.hidden = false;
    resultsEl.innerHTML = "";
    const isGift = (state.prefs || []).includes("pref_weekly_letter");
    const msg = isGift
      ? (root.dataset.msgGift || "We're sending you a free gift — check your email for how to claim it!")
      : (root.dataset.msgCoupon || "Your gift code is on its way — check your inbox!");
    const names = personas.map(k => (PERSONAS[k] || PERSONAS.curator).name).join(" & ");
    const card = el("div", "bm-quiz__result-card");
    const eyebrow = el("p", "bm-quiz__eyebrow"); eyebrow.textContent = "Your free gift is unlocked 🎁"; card.appendChild(eyebrow);
    const h = el("h2", "bm-quiz__persona"); h.textContent = names; card.appendChild(h);
    const gift = el("div", "bm-quiz__gift"); gift.textContent = msg; card.appendChild(gift);
    const cta = document.createElement("a"); cta.className = "bm-quiz__cta"; cta.href = "/collections/new-arrivals"; cta.textContent = "Shop your style";
    card.appendChild(cta);
    resultsEl.appendChild(card);
  }
}

// --- helpers ---
function loadState(STORE) {
  let s = {};
  try { s = JSON.parse(sessionStorage.getItem(STORE) || "{}"); } catch (e) { s = {}; }
  s.answers = s.answers || {}; s.prefs = s.prefs || []; s.birthday = s.birthday || {};
  return s;
}
function el(tag, cls) { const e = document.createElement(tag); if (cls) e.className = cls; return e; }
function select(opts, current) {
  const s = el("select", "bm-quiz__select");
  opts.forEach(o => { const op = document.createElement("option"); op.value = o.v; op.textContent = o.t; if (o.v === current) op.selected = true; s.appendChild(op); });
  return s;
}
function pad(n) { return String(n).padStart(2, "0"); }
function seq(a, b, stepv) { stepv = stepv || 1; const out = []; if (stepv > 0) for (let i = a; i <= b; i += stepv) out.push(i); else for (let i = a; i >= b; i += stepv) out.push(i); return out; }
function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }
function escapeHtml(s) { return String(s).replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c])); }
})();
